import script from "./SubstudyTaskForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SubstudyTaskForm.vue?vue&type=script&setup=true&lang=js"

import "./SubstudyTaskForm.vue?vue&type=style&index=0&id=7a9b07d4&scoped=true&lang=css"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a9b07d4"]])

export default __exports__